import styled from 'styled-components';
import { screen } from '@/helpers/screen';
import { FlexRowWrap } from '@/components/Grid/Flex';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const IconsWrapper = styled.section`
  padding: 40px 0;

  ${screen.md} {
    padding: 60px 0;
  }

  ${screen.lg} {
    padding: 80px 0;
  }

  ${screen.xxlg} {
    padding: 100px 0;
  }
`;

export const ImageWrapper = styled.img`
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: auto;
  object-fit: contain;
  max-height: 70px;

  ${screen.lg} {
    max-height: 80px;
  }

  ${screen.xxlg} {
    max-height: 100px;
  }
`;

export const LogosWrapper = styled(FlexRowWrap)`
  display: grid;
  gap: 33px;

  ${screen.md} {
    grid-template-columns: repeat(4, 1fr);
  }

  ${screen.lg} {
    gap: 48px;
  }

  ${screen.xxlg} {
    gap: 60px;
  }
`;

export const Title = styled.h1`
  margin: 0 auto;
  font-family: ${getToken('platform-font-title')};
  color: rgb(${getToken('color-text-primary')});
  font-weight: ${getToken('font-weight-bold')};
  font-size: 48px;
  line-height: 60px;
  text-align: center;
`;

export const Content = styled.p`
  margin: 40px auto 32px;

  font-family: ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-primary')});
  font-weight: ${getToken('font-weight-regular')};
  font-size: 20px;
  line-height: 36px;
  text-align: center;

  ${screen.md} {
    margin: 40px auto 64px;
  }
`;
